import { render, staticRenderFns } from "./form-dialog.vue?vue&type=template&id=2a45e788"
import script from "./form-dialog.vue?vue&type=script&lang=ts"
export * from "./form-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports